<div class="app-frame">
  @if (!isAdmin()) {
    <app-site-header />
  }
  <main class="app-main" [class.admin-route]="isAdmin()">
    <router-outlet />
  </main>
  @if (!isAdmin()) {
    <app-site-footer />
  }
</div>
